import styled from "styled-components";

export const StyledBasedOn = styled.h1`
	font-size: 5.6rem;
	font-weight: 900;
	margin-top: 2.4rem;
	margin-bottom: 1.8rem;
`;
